import Skeleton from '@/components/ui/custom/Skeleton';

export default function SectionSkeleton() {
  return (
    <Skeleton
      testId="sectionSkeleton"
      className="my-1 h-8 w-full rounded-lg bg-primary/10"
    />
  );
}
